import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const PremiumLabelContainer = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const LifetimeTrialLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  color: ${({ theme }) => theme.palette.info.main};
`;
